export const ActionsListCategory = {
	GET_LIST_CATEGORY: "get_list_category",
	LOAD_GET_LIST_CATEGORY: "load_get_list_category",
	RES_GET_LIST_CATEGORY: "res_get_list_category",
	ERR_GET_LIST_CATEGORY: "err_get_list_category",
	HYDRATE: "HYDRATE",
};

export function failureListCategory(err) {
	return {
		type: ActionsListCategory.ERR_GET_LIST_CATEGORY,
		err,
	};
}

export function loadListCategory(params = {}) {
	return {
		type: ActionsListCategory.GET_LIST_CATEGORY,
		...params,
	};
}

export function loadGetListCategory(params = {}) {
	return {
		type: ActionsListCategory.LOAD_GET_LIST_CATEGORY,
		...params,
	};
}

export function loadListCategorySuccess(data) {
	return {
		type: ActionsListCategory.RES_GET_LIST_CATEGORY,
		data,
	};
}
